// Reihenfolge der Stilschichten — die Zeile unten muss UEBER `./App` stehen.
// ES-Importe werten in Quelltextreihenfolge aus, und App zieht ./styles.css
// ueber seinen eigenen Importgraphen mit; was danach kommt, landet SPAETER im
// gebauten CSS. Als die Tokenschicht zuletzt landete, gewann :root des
// Design-Systems gegen das :root dieser App und toetete --card-strong still.
//
//   1. design-system v3 — die Token (--brand, --space-*, --radius-*, --text-*).
//      styles.css nennt rund 50 Token, die es selbst nicht definiert; ohne
//      diese Schicht loest jedes var() ins Leere, und Ueberschriften wie
//      Kachelnamen verschwinden ganz — sie malen ueber
//      `-webkit-text-fill-color: transparent` auf einem Verlauf aus
//      --text/--brand.
//   2. App-Stile — serviceAnt-eigene Ueberschreibungen, ueber ./App unten.
//
// Die frueheren Punkte 2 und 3 (ui-react styles.css und dist/index.css) gibt
// es nicht mehr, siehe unten.
/* v3 statt v2. `v3/base.css` zieht `compat/v2-aliases.css` selbst mit, die
   v2-Namen loesen also weiter auf.

   Die beiden ui-react-Stylesheets sind ersatzlos entfallen: 3.x liefert GAR
   KEIN CSS mehr aus (weder `styles.css` noch `dist/index.css` existieren im
   Paket), die Bauteile stylen inline und ueber die Klassen des
   Design-Systems. Waeren die Zeilen stehengeblieben, haette der Bau sie als
   fehlende Module gemeldet. */
import '@weretradeit/design-system/v3/base.css';

import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import './styles.css';

const container = document.getElementById('root');

if (container) {
  const root = createRoot(container);
  root.render(
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
}
